module.exports = __webpack_public_path__ + "static/media/random_materials.30a7e5cb.jpg";